import React from 'react';

const ReportsHubPage = React.lazy(() => import('./ReportsHubPage'));

const ReportsHubConfig = {
	settings: { layout: { config: {} } },
	routes: [
		{
			path: '/billing/reports',
			element: (
				<React.Suspense fallback={<>...</>}>
					<ReportsHubPage />
				</React.Suspense>
			),
		},
	],
	auth: ['school_admin', 'super_school_admin', 'sub_admin'],
};

export default ReportsHubConfig;
